// src/components/dashboard/table-planner/TablesPanel.jsx
import TableCard from "./TableCard";

export default function TablesPanel(props) {
  const {
    tables,
    onAddTable,
    tableSearchTerm,
    onTableSearchChange,
    onMainDragOver,
    tableRefs,
  } = props;

  return (
    <div className="lg:col-span-2 space-y-6" onDragOver={onMainDragOver}>
      <div className="sticky top-4 z-10">
        <input
          type="text"
          value={tableSearchTerm}
          onChange={onTableSearchChange}
          placeholder="Search by table name or number..."
          className="w-full mb-2 px-4 py-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-[#931b1c]"
        />
      </div>

      <button
        onClick={onAddTable}
        className="w-full py-3 bg-green-600 text-white font-bold rounded-xl hover:bg-green-700"
      >
        + Add New Table
      </button>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {tables.map((table) => (
          <TableCard
            key={table.id}
            // Add the ref assignment here
            ref={(el) => {
              if (tableRefs) tableRefs.current[table.id] = el;
            }}
            table={table}
            {...props}
          />
        ))}
        {tables.length === 0 && (
          <p className="text-gray-500 md:col-span-2 text-center">
            No tables match your search.
          </p>
        )}
      </div>
    </div>
  );
}
